const API_URL = "https://sonapi.nantech.az/api/Basket";

export const getBasketItems = async () => {
  try {
    const response = await fetch(`${API_URL}/list`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
        
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch basket items.");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching basket items:", error);
    return [];
  }
};

export const addToBasket = async (productId, quantity) => {
  try {
    const response = await fetch(`${API_URL}/${productId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
      },
      body: JSON.stringify({ quantity }),
    });
    if (!response.ok) {
      throw new Error("Failed to add product to basket.");
    }
    return await response.json();
  } catch (error) {
    console.error("Error adding to basket:", error);
    throw error;
  }
};

export const removeFromBasket = async (productId) => {
  try {
    const token = localStorage.getItem("accessToken"); 

    if (!token) {
      throw new Error("User is not authenticated."); 
    }

    const response = await fetch(`${API_URL}/${productId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
    });

    if (!response.ok) {
      throw new Error("Failed to remove product from basket.");
    }

    return await response.json();
  } catch (error) {
    console.error("Error removing from basket:", error);
    throw error;
  }
};
export const updateBasketQuantity = async (userId, productId, change) => {
  try {
    const token = localStorage.getItem("accessToken"); 

    if (!token) {
      throw new Error("User is not authenticated."); 
    }

    const response = await fetch(`${API_URL}/${userId}/${productId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(change),  
    });

    if (!response.ok) {
      throw new Error("Failed to update basket quantity.");
    }
    return await response.json();
  } catch (error) {
    console.error("Error updating basket quantity:", error);
    throw error;
  }
};

export const checkoutBasket = async (userId) => {
  try {
    const response = await fetch(`${API_URL}/checkout?userId=${userId}`, {
      method: 'POST', 
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`, 
      },
      body: JSON.stringify({}),  
    });

    if (!response.ok) {
      throw new Error('Checkout zamanı xəta baş verdi');
    }

    const data = await response.json();
    return data; 
  } catch (error) {
    console.error('Error during checkout:', error);
    throw error;
  }
};


